import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from '../services/auth.guard'
import { OohComponent } from 'app/mobility/ooh/ooh.component'
import { CampaignsComponent } from 'app/mobility/campaigns/campaigns.component'

const routes: Routes = [
  {
    path: 'ooh',
    canActivate: [AuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'map' },
      { path: 'map', component: OohComponent },
      { path: 'campaigns', component: CampaignsComponent },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MobilityRoutingModule {}
